export default __webpack_public_path__ + "static/media/sports_top.cb5e633a.svg";